import ProcessQuoteLoader from './process-quote-loader';

export default ProcessQuoteLoader;
